export const SMALL_BALE_UNIT = 80;
export const ROUND_BALE_UNIT = 81;
export const CUBIC_BALE_UNIT = 82;
export const WAGON_UNIT = 83;

export const KG_UNIT_TYPE = 13;
export const DRY_CONTENT_UNIT_TYPE = 15;

// Randomly chosen number for bales
export const BALE_UNIT = 102;

export const STORAGE_PROPERTY_TYPE_HARVEST = 5;